import { Injectable, inject } from '@angular/core';
import { CoreActions } from '@next/core-lib';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { finalize, map, mergeMap, startWith } from 'rxjs/operators';

import {
  MilkDeliveryMonthSummary,
  MilkDeliveryState,
  MilkDeliverySummary,
} from '../../models/milk-delivery.model';
import { MilkDeliveryService } from '../../services/milk-delivery.service';
import * as MilkDeliveryActions from '../actions/milk-delivery.actions';

@Injectable()
export class MilkDeliveryEffects {
  private readonly actions$ = inject(Actions);
  private readonly milkDeliveryService = inject(MilkDeliveryService);
  private readonly store = inject<Store<MilkDeliveryState>>(Store);

  protected getMilkDeliveries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MilkDeliveryActions.loadMilkDeliveriesRequest),
      mergeMap((values) =>
        this.milkDeliveryService.get(values.start, values.end).pipe(
          map((milkDeliverySummary: MilkDeliverySummary[]) =>
            MilkDeliveryActions.loadMilkDeliveriesSuccess({ milkDeliverySummary }),
          ),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
        ),
      ),
    ),
  );

  protected getMilkDeliveriesMonthSummary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MilkDeliveryActions.loadMilkDeliveriesMonthSummaryRequest),
      mergeMap((values) =>
        this.milkDeliveryService.getMonthSummary(values.start, values.end).pipe(
          map((milkDeliveryMonthSummary: MilkDeliveryMonthSummary) =>
            MilkDeliveryActions.loadMilkDeliveriesMonthSummarySuccess({ milkDeliveryMonthSummary }),
          ),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
        ),
      ),
    ),
  );
}
